module.exports = __webpack_public_path__ + "img/cse.66f6870e.png";